var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "editor",
      staticClass: "vue-excel-editor",
      style: { display: "inline-block", width: _vm.width },
    },
    [
      _c(
        "div",
        { staticClass: "component-content" },
        [
          _vm.localizedLabel.noRecordIndicator && _vm.pagingTable.length == 0
            ? _c(
                "div",
                {
                  staticClass: "norecord",
                  style: { bottom: _vm.noFooter ? "12px" : "37px" },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.localizedLabel.noRecordIndicator) + " "
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              ref: "tableContent",
              staticClass: "table-content",
              class: { "no-footer": _vm.noFooter },
              on: {
                scroll: _vm.tableScroll,
                mouseover: _vm.mouseOver,
                mouseout: _vm.mouseOut,
              },
            },
            [
              _c(
                "table",
                {
                  ref: "systable",
                  staticClass: "systable",
                  class: { "no-number": _vm.noNumCol },
                  staticStyle: { "table-layout": "fixed", width: "0" },
                  attrs: {
                    id: "systable",
                    ondragenter:
                      "event.preventDefault(); event.dataTransfer.dropEffect = 'none'",
                    ondragover:
                      "event.preventDefault(); event.dataTransfer.dropEffect = 'none'",
                  },
                },
                [
                  _c(
                    "colgroup",
                    [
                      !_vm.noNumCol
                        ? _c("col", { staticStyle: { width: "40px" } })
                        : _vm._e(),
                      _vm._l(_vm.fields, function (item, p) {
                        return _c("col", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !item.invisible,
                              expression: "!item.invisible",
                            },
                          ],
                          key: p,
                          style: { width: item.width },
                        })
                      }),
                      _vm.vScroller.buttonHeight < _vm.vScroller.height
                        ? _c("col", { staticStyle: { width: "12px" } })
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("thead", { staticClass: "center-text" }, [
                    _c(
                      "tr",
                      [
                        _c(
                          "th",
                          {
                            staticClass: "center-text first-col tl-setting",
                            class: { hide: _vm.noNumCol },
                            staticStyle: { top: "0" },
                            on: {
                              mousedown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "left",
                                    37,
                                    $event.key,
                                    ["Left", "ArrowLeft"]
                                  )
                                ) {
                                  return null
                                }
                                if ("button" in $event && $event.button !== 0) {
                                  return null
                                }
                                return _vm.selectAllClick.apply(null, arguments)
                              },
                              contextmenu: function ($event) {
                                $event.preventDefault()
                                return _vm.settingClick.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("span", { staticStyle: { width: "100%" } }, [
                              _vm.selectedCount > 0
                                ? _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-inline--fa fa-times-circle fa-w-16 fa-sm",
                                      attrs: {
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        "data-prefix": "fas",
                                        "data-icon": "times-circle",
                                        role: "img",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 512 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "currentColor",
                                          d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z",
                                        },
                                      }),
                                    ]
                                  )
                                : _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-inline--fa fa-bars fa-w-14 fa-sm",
                                      attrs: {
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        "data-prefix": "fas",
                                        "data-icon": "bars",
                                        role: "img",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 448 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "currentColor",
                                          d: "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z",
                                        },
                                      }),
                                    ]
                                  ),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.fields, function (item, p) {
                          return _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !item.invisible,
                                  expression: "!item.invisible",
                                },
                              ],
                              key: "th-" + p,
                              class: {
                                "sort-asc-sign":
                                  _vm.sortPos == p && _vm.sortDir == 1,
                                "sort-des-sign":
                                  _vm.sortPos == p && _vm.sortDir == -1,
                                "sticky-column": item.sticky,
                              },
                              style: { left: item.left },
                              attrs: {
                                colspan:
                                  p === _vm.fields.length - 1 &&
                                  _vm.vScroller.buttonHeight <
                                    _vm.vScroller.height
                                    ? 2
                                    : 1,
                              },
                              on: {
                                mousedown: function ($event) {
                                  return _vm.headerClick($event, p)
                                },
                                contextmenu: function ($event) {
                                  $event.preventDefault()
                                  return _vm.panelFilterClick(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: { "filter-sign": _vm.columnFilter[p] },
                                },
                                [
                                  _c("span", {
                                    class: {
                                      "table-col-header": !_vm.noHeaderEdit,
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.headerLabel(item.label, item)
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sep",
                                  on: {
                                    mousedown: _vm.colSepMouseDown,
                                    mouseover: _vm.colSepMouseOver,
                                    mouseout: _vm.colSepMouseOut,
                                  },
                                },
                                [
                                  _c("div", { staticClass: "add-col-btn" }, [
                                    _vm._v(" + "),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      { class: { hide: !_vm.filterRow } },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "center-text first-col tl-filter",
                            class: { hide: _vm.noNumCol },
                            staticStyle: {
                              "vertical-align": "middle",
                              padding: "0",
                            },
                            style: { top: _vm.calCellTop2 + "px" },
                            on: {
                              click: function ($event) {
                                _vm.columnFilter = {}
                              },
                            },
                          },
                          [
                            Object.keys(_vm.columnFilter).length > 0
                              ? _c("span", [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-inline--fa fa-eraser fa-w-16 fa-sm",
                                      attrs: {
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        "data-prefix": "fas",
                                        "data-icon": "eraser",
                                        role: "img",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 512 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "currentColor",
                                          d: "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z",
                                        },
                                      }),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._l(_vm.fields, function (item, p) {
                          return _c("vue-excel-filter", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !item.invisible,
                                expression: "!item.invisible",
                              },
                            ],
                            key: "th2-" + p,
                            ref: "filter-" + item.name,
                            refInFor: true,
                            staticClass: "column-filter",
                            class: { "sticky-column": item.sticky },
                            style: { left: item.left },
                            attrs: {
                              colspan: p === _vm.fields.length - 1 ? 2 : 1,
                            },
                            model: {
                              value: _vm.columnFilter[p],
                              callback: function ($$v) {
                                _vm.$set(_vm.columnFilter, p, $$v)
                              },
                              expression: "columnFilter[p]",
                            },
                          })
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c(
                    "tbody",
                    { on: { mousedown: _vm.mouseDown } },
                    [
                      _vm.localizedLabel.noRecordIndicator &&
                      _vm.pagingTable.length == 0
                        ? _c("tr", [
                            _c("td", {
                              staticStyle: {
                                height: "40px",
                                "vertical-align": "middle",
                                "text-align": "center",
                              },
                              attrs: { colspan: "100%" },
                            }),
                          ])
                        : _vm._l(_vm.pagingTable, function (record, rowPos) {
                            return _c(
                              "tr",
                              {
                                key: rowPos,
                                class: {
                                  select:
                                    typeof _vm.selected[
                                      _vm.pageTop + rowPos
                                    ] !== "undefined",
                                },
                                style: _vm.rowStyle(record),
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "center-text first-col",
                                    class: {
                                      hide: _vm.noNumCol,
                                      error: _vm.rowerr["rid-" + record.$id],
                                    },
                                    attrs: {
                                      id: "rid-" + record.$id,
                                      pos: rowPos,
                                    },
                                    on: {
                                      mouseover: _vm.numcolMouseOver,
                                      click: _vm.rowLabelClick,
                                    },
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.recordLabel(
                                            _vm.pageTop + rowPos + 1,
                                            record
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._l(_vm.fields, function (item, p) {
                                  return _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !item.invisible,
                                          expression: "!item.invisible",
                                        },
                                      ],
                                      key: p,
                                      class: {
                                        readonly: item.readonly,
                                        error:
                                          _vm.errmsg[
                                            "id-" + record.$id + "-" + item.name
                                          ],
                                        link: item.link,
                                        select: item.options,
                                        datepick: item.type == "date",
                                        "sticky-column": item.sticky,
                                      },
                                      style: Object.assign(
                                        _vm.cellStyle(record, item),
                                        _vm.renderColumnCellStyle(item)
                                      ),
                                      attrs: {
                                        id:
                                          "id-" + record.$id + "-" + item.name,
                                        "cell-RC": rowPos + "-" + item.name,
                                      },
                                      on: {
                                        mouseover: _vm.cellMouseOver,
                                        mousemove: _vm.cellMouseMove,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.toText(record[item.name]))
                                      ),
                                    ]
                                  )
                                }),
                                _vm.vScroller.buttonHeight <
                                _vm.vScroller.height
                                  ? _c("td", { staticClass: "last-col" })
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                    ],
                    2
                  ),
                  _c("tfoot", [
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.pagingTable.length && _vm.summaryRow,
                            expression: "pagingTable.length && summaryRow",
                          },
                        ],
                      },
                      [
                        _c("td", { staticClass: "row-summary first-col" }, [
                          _vm._v(" "),
                        ]),
                        _vm._l(_vm.fields, function (field, p) {
                          return _c(
                            "td",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !field.invisible,
                                  expression: "!field.invisible",
                                },
                              ],
                              key: "f" + p,
                              staticClass: "row-summary",
                              class: {
                                "sticky-column": field.sticky,
                                "summary-column1":
                                  p + 1 < _vm.fields.length &&
                                  _vm.fields[p + 1].summary,
                                "summary-column2": field.summary,
                              },
                              style: _vm.renderColumnCellStyle(field),
                              attrs: {
                                colspan:
                                  p === _vm.fields.length - 1 &&
                                  _vm.vScroller.buttonHeight <
                                    _vm.vScroller.height
                                    ? 2
                                    : 1,
                              },
                            },
                            [_vm._v(_vm._s(_vm.summary[field.name]))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._t("default"),
                ],
                2
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tip,
                      expression: "tip",
                    },
                  ],
                  ref: "tooltip",
                  staticClass: "tool-tip",
                },
                [_vm._v(_vm._s(_vm.tip))]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.textTip,
                      expression: "textTip",
                    },
                  ],
                  ref: "texttip",
                  staticClass: "text-tip",
                },
                [_vm._v(_vm._s(_vm.textTip))]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.focused,
                      expression: "focused",
                    },
                  ],
                  ref: "inputSquare",
                  staticClass: "input-square",
                  on: { mousedown: _vm.inputSquareClick },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        position: "relative",
                        height: "100%",
                        padding: "2px 2px 1px",
                      },
                    },
                    [
                      _c("div", { staticClass: "rb-square" }),
                      _c("textarea", {
                        ref: "inputBox",
                        staticClass: "input-box",
                        style: { opacity: _vm.inputBoxShow },
                        attrs: {
                          id: "inputBox",
                          trim: "",
                          autocomplete: "off",
                          autocorrect: "off",
                          autocompitaize: "off",
                          spellcheck: _vm.spellcheck,
                        },
                        on: {
                          blur: _vm.inputBoxBlur,
                          mousemove: _vm.inputBoxMouseMove,
                          mousedown: _vm.inputBoxMouseDown,
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDatePicker,
                      expression: "showDatePicker",
                    },
                  ],
                  ref: "dpContainer",
                  staticStyle: { "z-index": "20", position: "fixed" },
                },
                [
                  _c("date-picker", {
                    ref: "datepicker",
                    attrs: { inline: "", valueType: "format" },
                    on: { input: _vm.datepickerClick },
                    model: {
                      value: _vm.inputDateTime,
                      callback: function ($$v) {
                        _vm.inputDateTime = $$v
                      },
                      expression: "inputDateTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.processing,
                      expression: "processing",
                    },
                  ],
                  ref: "frontdrop",
                  staticClass: "front-drop",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "svg-inline--fa fa-spinner fa-w-16 fa-spin fa-3x",
                      attrs: {
                        "aria-hidden": "true",
                        focusable: "false",
                        "data-prefix": "fas",
                        "data-icon": "spinner",
                        role: "img",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 512 512",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "currentColor",
                          d: "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.vScroller.buttonHeight < _vm.vScroller.height,
                  expression: "vScroller.buttonHeight < vScroller.height",
                },
              ],
              ref: "vScroll",
              staticClass: "v-scroll",
              style: {
                top: _vm.vScroller.top + "px",
                height: _vm.vScroller.height + "px",
              },
              on: { mousedown: _vm.vsMouseDown },
            },
            [
              _c(
                "div",
                {
                  ref: "vScrollButton",
                  staticClass: "v-scroll-button",
                  style: {
                    marginTop: _vm.vScroller.buttonTop + "px",
                    height: _vm.vScroller.buttonHeight + "px",
                  },
                  on: { mousedown: _vm.vsbMouseDown },
                },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.vScroller.runner,
                        expression: "vScroller.runner",
                      },
                    ],
                    staticClass: "runner",
                    domProps: { innerHTML: _vm._s(_vm.vScroller.runner) },
                  }),
                ]
              ),
            ]
          ),
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.focused && _vm.autocompleteInputs.length,
                  expression: "focused && autocompleteInputs.length",
                },
              ],
              ref: "autocomplete",
              staticClass: "autocomplete-results",
            },
            _vm._l(_vm.autocompleteInputs, function (item, i) {
              return _c(
                "li",
                {
                  key: i,
                  staticClass: "autocomplete-result",
                  class: { select: _vm.autocompleteSelect === i },
                  on: {
                    mousedown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft",
                        ])
                      ) {
                        return null
                      }
                      if ("button" in $event && $event.button !== 0) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.inputAutocompleteText(
                        $event.target.textContent,
                        $event
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              ref: "footer",
              staticClass: "footer center-text",
              class: { hide: _vm.noFooter },
              staticStyle: { position: "relative" },
              on: { mousedown: _vm.ftMouseDown },
            },
            [
              _c("div", {
                ref: "hScroll",
                staticClass: "h-scroll",
                on: { mousedown: _vm.sbMouseDown },
              }),
              _c("span", { staticClass: "left-block" }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.noPaging,
                      expression: "!noPaging",
                    },
                  ],
                  staticStyle: { position: "absolute", left: "46px" },
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.localizedLabel.footerLeft(
                          _vm.pageTop + 1,
                          _vm.pageBottom,
                          _vm.table.length
                        )
                      ),
                    },
                  }),
                ]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.noPaging &&
                        _vm.pageBottom - _vm.pageTop < _vm.table.length,
                      expression:
                        "!noPaging && pageBottom - pageTop < table.length",
                    },
                  ],
                },
                [
                  _vm.processing
                    ? [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "svg-inline--fa fa-spinner fa-w-16 fa-spin fa-sm",
                            attrs: {
                              "aria-hidden": "true",
                              focusable: "false",
                              "data-prefix": "fas",
                              "data-icon": "spinner",
                              role: "img",
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 512 512",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d: "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z",
                              },
                            }),
                          ]
                        ),
                        _vm._v("   "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.localizedLabel.processing),
                          },
                        }),
                      ]
                    : [
                        _c(
                          "a",
                          {
                            class: { disabled: _vm.pageTop <= 0 },
                            on: { mousedown: _vm.firstPage },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "svg-inline--fa fa-step-backward fa-w-14 fa-sm",
                                attrs: {
                                  "aria-hidden": "true",
                                  focusable: "false",
                                  "data-prefix": "fas",
                                  "data-icon": "step-backward",
                                  role: "img",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 448 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v("   "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.localizedLabel.first),
                              },
                            }),
                          ]
                        ),
                        _vm._v("  |  "),
                        _c(
                          "a",
                          {
                            class: { disabled: _vm.pageTop <= 0 },
                            on: { mousedown: _vm.prevPage },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "svg-inline--fa fa-backward fa-w-16 fa-sm",
                                attrs: {
                                  "aria-hidden": "true",
                                  focusable: "false",
                                  "data-prefix": "fas",
                                  "data-icon": "backward",
                                  role: "img",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 512 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v("   "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.localizedLabel.previous),
                              },
                            }),
                          ]
                        ),
                        _vm._v("  |  "),
                        _c(
                          "a",
                          {
                            class: {
                              disabled:
                                _vm.pageTop + _vm.pageSize >= _vm.table.length,
                            },
                            on: { mousedown: _vm.nextPage },
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.localizedLabel.next),
                              },
                            }),
                            _vm._v("   "),
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "svg-inline--fa fa-forward fa-w-16 fa-sm",
                                attrs: {
                                  "aria-hidden": "true",
                                  focusable: "false",
                                  "data-prefix": "fas",
                                  "data-icon": "forward",
                                  role: "img",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 512 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v("  |  "),
                        _c(
                          "a",
                          {
                            class: {
                              disabled:
                                _vm.pageTop + _vm.pageSize >= _vm.table.length,
                            },
                            on: { mousedown: _vm.lastPage },
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.localizedLabel.last),
                              },
                            }),
                            _vm._v("   "),
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "svg-inline--fa fa-step-forward fa-w-14 fa-sm",
                                attrs: {
                                  "aria-hidden": "true",
                                  focusable: "false",
                                  "data-prefix": "fas",
                                  "data-icon": "step-forward",
                                  role: "img",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 448 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
              _c(
                "span",
                { staticStyle: { position: "absolute", right: "6px" } },
                [
                  _c(
                    "a",
                    {
                      class: {
                        disabled:
                          !_vm.showSelectedOnly && _vm.selectedCount <= 1,
                      },
                      on: { mousedown: _vm.toggleSelectView },
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.localizedLabel.footerRight.selected
                          ),
                        },
                      }),
                      _c(
                        "span",
                        {
                          style: {
                            color: _vm.selectedCount > 0 ? "red" : "inherit",
                          },
                        },
                        [_vm._v(_vm._s(_vm.selectedCount))]
                      ),
                    ]
                  ),
                  _vm._v("  |  "),
                  _c(
                    "a",
                    {
                      class: { disabled: _vm.columnFilterString === "{}" },
                      on: { mousedown: _vm.toggleFilterView },
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.localizedLabel.footerRight.filtered
                          ),
                        },
                      }),
                      _c(
                        "span",
                        {
                          style: {
                            color:
                              _vm.table.length !== _vm.filteredValue.length
                                ? "red"
                                : "inherit",
                          },
                        },
                        [_vm._v(_vm._s(_vm.table.length))]
                      ),
                    ]
                  ),
                  _vm._v("  |  "),
                  _c("a", { class: { disabled: true } }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.localizedLabel.footerRight.loaded
                        ),
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.filteredValue.length))]),
                  ]),
                ]
              ),
            ]
          ),
          _c("input", {
            ref: "importFile",
            staticStyle: {
              position: "absolute",
              top: "0",
              left: "0",
              width: "0",
              height: "0",
              opacity: "0",
              "z-index": "-1",
            },
            attrs: { type: "file", accept: ".xlsx, .xls, xlsm, .csv" },
            on: { keyup: _vm.componentTabInto, change: _vm.doImport },
          }),
          _c("panel-filter", {
            ref: "panelFilter",
            attrs: {
              "n-filter-count": _vm.nFilterCount,
              "localized-label": _vm.localizedLabel,
            },
          }),
          _c("panel-setting", {
            ref: "panelSetting",
            attrs: { "localized-label": _vm.localizedLabel },
            model: {
              value: _vm.fields,
              callback: function ($$v) {
                _vm.fields = $$v
              },
              expression: "fields",
            },
          }),
          _c("panel-find", {
            ref: "panelFind",
            attrs: { "localized-label": _vm.localizedLabel },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }